import React from "react";
import { useSelector } from "react-redux";
import { useNavigation } from "@react-navigation/native";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";
import { kRoute } from "src/kRoute";
import { kStyleConst } from "src/kStyle";
import { useIsMobile, useUserProfile } from "src/hooks/ui";
import { sortBy } from "lodash";

const ShopSubHeader: React.FC<{ onPress?: (item: string | undefined) => void }> = ({ onPress }) => {
  const { isBrand, isRep } = useUserProfile();
  const rConfigs = useSelector((state) => state.ConfigsReducer);
  const navigation = useNavigation();
  const isMobile = useIsMobile();

  const categories = React.useMemo(() => {
    const _categories: string[] = [];
    for (const category of Object.keys(rConfigs.data.shop?.productCategories ?? {})) {
      if (category !== "Sales Assets & Display Units" && category !== "Holiday") _categories.push(category);
    }
    return _categories;
  }, [rConfigs.data.shop?.productCategories]);

  const handleOnPressBrands = () => {
    navigation.navigate(kRoute.P99, { category: undefined });
    onPress?.(undefined);
  };

  const handleOnPressItem = (item: string) => {
    navigation.navigate(kRoute.P99, { category: item });
    onPress?.(item);
  };

  if (
    rConfigs.isLoading ||
    Object.keys(rConfigs.data.shop?.productCategories ?? {}).length === 0 ||
    isMobile ||
    isBrand ||
    isRep
  ) {
    return null;
  }

  return (
    <View style={styles.gSubHeaderContainer}>
      {sortBy(categories, (category) => category).map((category) => (
        <TouchableOpacity key={category} style={styles.gSubHeaderCell} onPress={() => handleOnPressItem(category)}>
          <Text style={styles.fSubHeaderWhite}>{category}</Text>
        </TouchableOpacity>
      ))}
      <Text style={styles.fSubHeaderDivider}> | </Text>
      <TouchableOpacity onPress={handleOnPressBrands}>
        <Text style={styles.fSubHeaderWhite}>All Brands</Text>
      </TouchableOpacity>
    </View>
  );
};

export default ShopSubHeader;

const styles = StyleSheet.create({
  fSubHeaderDivider: {
    ...kFonts.subHeader,
    color: kColors.white,
    marginEnd: 6 * kStyleConst.kSpacing,
  },
  fSubHeaderWhite: {
    ...kFonts.subHeader,
    color: kColors.white,
    fontSize: 10,
  },
  gSubHeaderCell: {
    marginHorizontal: 4 * kStyleConst.kSpacing,
  },
  gSubHeaderContainer: {
    alignItems: "center",
    backgroundColor: kColors.brandGreen,
    flexDirection: "row",
    height: kStyleConst.kSubHeaderHeight,
    justifyContent: "center",
    width: "100%",
  },
});
